import React from 'react'
import { FulfillmentTimeRow } from './FulfillmentTimeRow'

interface DeliveryFulfillmentTimeProps {
  className?: string
}

export const DeliveryFulfillmentTime: React.FC<
  DeliveryFulfillmentTimeProps
> = ({ className }) => {
  return (
    <FulfillmentTimeRow
      className={className}
      testId='delivery-fulfillment-time-display'
      translationPrefix='delivery-fulfillment-time'
    />
  )
}

export default DeliveryFulfillmentTime
